import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/servicio/servicioSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import ServicioView from '../view/ServicioView';

function ServicioListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerServicioViewPage'}
          type={props.type || 'chip'}
          entity={'servicio'}
          tooltipTitle={i18n(record.descripcion)}
          buttonTitle={i18n(record.descripcion)}
          width={window.innerWidth * 0.55}
          record={record}
          component={<ServicioView record={record} drawer={true} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

ServicioListItem.propTypes = {
  value: PropTypes.any,
  type: PropTypes.string,
};

export default ServicioListItem;
